import * as Sentry from "@sentry/react-native"
import * as Localization from "expo-localization"
import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import { resources } from "./resources"
import { logger } from "@/base/logger"

export const DEFAULT_NAMESPACE = "common"
export const SUPPORTED_APP_LANGUAGE_CODES = ["en", "es", "fr", "it"] as const

// There are continued polyfill problems with pluralrules etc. TODO: Fix
export type SupportedAppLanguageCode =
  (typeof SUPPORTED_APP_LANGUAGE_CODES)[number]

function convertLanguageCodeToSupportedLanguage(
  code: string | undefined,
): SupportedAppLanguageCode {
  if (!code) {
    return "en"
  }
  const [languageBase] = code.split("-")
  if (
    SUPPORTED_APP_LANGUAGE_CODES.includes(
      languageBase as SupportedAppLanguageCode,
    )
  ) {
    return languageBase as SupportedAppLanguageCode
  }
  return "en"
}
const LOCALE = convertLanguageCodeToSupportedLanguage(
  Localization.getLocales()[0]?.languageTag,
)

// https://www.i18next.com/overview/configuration-options
// throw new TypeError(process.env.NODE_ENV)
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    compatibilityJSON: "v3",
    defaultNS: DEFAULT_NAMESPACE,
    fallbackLng: ["en"],
    interpolation: {
      escapeValue: false,
      skipOnVariables: false, // react already safes from xss
    },
    lng: process.env.NODE_ENV === "test" ? "en" : LOCALE,
    missingInterpolationHandler: (text, value, options) => {
      const namespace = `${JSON.stringify(options.ns)}`
      const valueAsString = JSON.stringify(value, null, 2)
      Sentry.captureMessage(
        `interpolation value is undefined for text: ${text}
        \nvalue=${valueAsString}\nnamespace=${namespace}`,
        {
          tags: {
            lng: options.lng,
            locale: LOCALE,
            namespace,
          },
        },
      )
    },
    resources,
  })
  .catch((error) => {
    Sentry.captureException(error)
    logger.error(error)
  })

export default i18n
